import React, { useEffect } from 'react';
import clsx from 'clsx';
import { LuX } from 'react-icons/lu';

export interface ModalProps {
  className?: string;
  closeButtonClassName?: string;
  visible: boolean;
  onClose: () => void;
}

export const Modal = ({
  children,
  className,
  closeButtonClassName = 'absolute top-0 right-0 p-2',
  visible,
  onClose,
}: React.PropsWithChildren<ModalProps>) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (visible && event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, visible]);

  return (
    visible && (
      <div
        className={clsx(
          'fixed top-0 left-0 h-screen w-screen bg-neutral-700 bg-opacity-50 z-50',
        )}
      >
        <div
          className={clsx(
            'absolute left-1/2 top-1/2 transform -translate-x-1/2',
            '-translate-y-full bg-white rounded-lg w-1/3 min-h-64 max-h-96',
            className,
          )}
        >
          <button
            type="button"
            onClick={onClose}
            className={closeButtonClassName}
          >
            <LuX className="w-8 h-8" />
          </button>

          {children}
        </div>
      </div>
    )
  );
};
